export { WelcomeBanner } from "./src/old-welcome-banner";
// M2 components
export { PartnerWelcomeBanner } from "./src/partner-welcome-banner";
export { CustomerWelcomeBanner } from "./src/customer-welcome-banner";
